import detailStyles from '../ChallengeDetail.module.scss';
import image121 from './images/12-1.jpg';
import image122 from './images/12-2.jpg';
import image123 from './images/12-3.jpg';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';

export const TakePartQuizDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>«Заработок»</b>
                </div>
                <ChallengeDetailHelpImage image={image121} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Зайдите в подраздел <b>«Участвовать в викторине»</b>
                </div>
                <ChallengeDetailHelpImage image={image122} helpText='Это картинка. Ищите подраздел в разделе «Заработок».' />
            </p>
            
            <p>
                <div>
                    Укажите ваш пол и возраст, выбирите тему и нажмите кнопку <b>«Начать викторину»</b>
                </div>
                <ChallengeDetailHelpImage image={image123} helpText='Это картинка. Ищите кнопку в подразделе «Участовать в викторине».' />
            </p>
        </div>
    );
}